import { navigatorDetails } from 'UTILS/navigator';
import { getBrowserAndOSInfo } from 'UTILS/callbacks';

const start = ({
  onError = () => {},
  onSuccess = () => {},
  onEnd = () => {},
}) => {
  const result = getBrowserAndOSInfo(navigatorDetails);
  onEnd();
  if (result.resultLevel === 'success') {
    onSuccess(result.message, { browserName: result.browserName });
    return true;
  } else {
    switch (result.message) {
      case 'browser_outdated': {
        onError('browser_outdated', { browserName: result.browserName, browserMinVersion: result.browserMinVersion, browserVersion: result.browserVersion, os: result.os });
        break;
      }
      case 'browser_not_supported':
      case 'browser_not_meeting_requirements': {
        onError(result.message, { browserName: result.browserName, os: result.os });
        break;
      }
      case 'browser_not_safari_on_iOS':
      case 'browser_not_chrome_on_android': {
        onError(result.message);
        break;
      }
    }
  }

  return false;
};

export default {
  start,
};
